import scrollama from "scrollama";

function animateFraworkSvgs(){
    // instantiate the scrollama
    const scroller = scrollama();

    const ANIM_TIME = 1500;

    // setup the instance, pass callback functions
    scroller
    .setup({
            step: ".section-cons-framework",
            offset: 0.9
    })
    .onStepEnter((response) => {
        const svgIconsAnim = document.querySelectorAll(".framework-item-container");
        svgIconsAnim.forEach(function(svgContainer, idx){
            svgContainer.classList.remove("active");
            setTimeout(() => {
                svgContainer.classList.add("active");
                setTimeout(() => {
                    svgContainer.classList.remove("active");
                }, ANIM_TIME/4*3);
            }, idx * ANIM_TIME);
        });
    });

}

export { animateFraworkSvgs }